import React, { Component } from 'react';
import { connect } from 'react-redux'
import cn from 'classnames';

import { detectTabFocus } from '../../decorators';
import { browserHistory } from '../../browserHistory';
import services, { events } from '../../services/services';
import { getReminderTypesByCompanyId, getReasonTypesByCompanyId } from '../../services/apiChat';
import { exposeComponentToGlobalScope, setToLocalStorage } from '../../utils/utilsGlobal';
import { generateRoomURL } from '../../utils/utilsChat';
import { setReminderTypes, setReasonTypes } from '../../actions/actions';

import {
  Chat,
  RoomList,
  LoadingScreen,
  RightSideSettings,
} from '../../components';

import styles from './PageChat.scss';


const mapStateToProps = state => {
  return {
    isLoggedIn: state.isLoggedIn,
    authToken: state.authToken,
    currentRoom: state.currentRoom,
    currentCompany: state.currentCompany,
    currentOperator: state.currentOperator,
    isMobileMenuEnabled: state.isMobileMenuEnabled,
    isMobileSidebarEnabled: state.isMobileSidebarEnabled,
    newVersionAvailable: state.newVersionAvailable,
    workHoursSchedulerIsWorking: state.workHoursSchedulerIsWorking,
  }
};

const mapDispatchToProps = { setReminderTypes, setReasonTypes };

@connect(mapStateToProps, mapDispatchToProps)
@detectTabFocus()
export class PageChat extends Component {

  state = {
    isLoading: false,
    isInitialized: false,
  };

  componentDidMount(){
    services.userWatcher.on(events.USER_SET_SUCCESS, this.fetchRoomData);
    exposeComponentToGlobalScope(this);
  }

  componentDidUpdate(prevProps){
    const { match, currentCompany } = this.props;
    const { roomId } = match.params;
    const { isInitialized } = this.state;

    if (roomId !== prevProps.match.params.roomId && isInitialized) {
      services.roomListSubscription.setCurrentRoomById(roomId, true).then(currentRoom => {
        setToLocalStorage('LATEST_OPENED_ROOM_' + currentCompany.id, currentRoom.id);
        this.redirectToLoadedRoom(roomId, currentCompany);
      });
    }
  }

  fetchRoomData = (currentCompany) => {
    const { setReminderTypes, setReasonTypes, currentOperator, match } = this.props;
    const { roomId } = match.params;

    this.setState({ isLoading: true });
    services.roomListSubscription.reset();

    return services.roomListSubscription.initialize({ currentOperator, currentCompany })
      .then(() => services.roomListSubscription.setRoomsByFilter(services.roomListSubscription.defaultFilter))
      .then(() => services.roomListSubscription.setCurrentRoomById(roomId, true))
      .then(() => this.redirectToLoadedRoom(roomId, currentCompany))
      .then(() => getReminderTypesByCompanyId(currentCompany.id).then(setReminderTypes))
      .then(() => getReasonTypesByCompanyId(currentCompany.id).then(setReasonTypes))
      .then(() => {
        this.setState({
          isLoading: false,
          isInitialized: true,
        });
      });
  };

  redirectToLoadedRoom = (roomId, currentCompany) => {
    const loadedRoomId = services.roomListSubscription.currentRoom.id;
    if (roomId !== loadedRoomId) {
      const currentRoomPath = generateRoomURL(currentCompany.id, loadedRoomId);
      browserHistory.push(currentRoomPath);
    }
  };

  render(){
    const {
      currentOperator,
      currentCompany,
      newVersionAvailable,
      workHoursSchedulerIsWorking,
      isMobileMenuEnabled,
      isMobileSidebarEnabled,
      isLoggedIn,
      match,
    } = this.props;

    const { roomId } = match.params;
    const { isLoading } = this.state;

    const showLoadingScreen = isLoading
      || !isLoggedIn
      || !roomId
      || !currentCompany.id
      || !currentOperator.id;

    if (showLoadingScreen) {
      return (
        <LoadingScreen/>
      );
    }

    const isAppBlurred = currentOperator.hasSchedule && !workHoursSchedulerIsWorking;

    return (
      <div className={cn({
        [styles.container]: true,
        [styles.containerInactive]: isAppBlurred,
        [styles.containerNewVersionAvailable]: newVersionAvailable,
      })}>

        <RoomList className={cn({
          [styles.roomList]: true,
          [styles.roomListMobileOverlap]: isMobileMenuEnabled,
        })}/>

        <Chat className={styles.chat}/>

        <RightSideSettings className={cn({
          [styles.rightSideSettings]: true,
          [styles.rightSideSettingsMobileOverlap]: isMobileSidebarEnabled,
        })}
        />
      </div>
    );
  }
}
